<template>
  <section class="app-content">
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppContent",
};
</script>

<style scoped></style>
